import React from 'react'
import styled from 'styled-components'
import Image from 'next/image'
import FeedbackFormLink from '../FeedbackFormLink'

const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${({ theme }) => theme.colors.primary};
`

const OverlayItem = ({ icon, label, show }) =>
  show && (
    <div className='mb-2'>
      <Image alt={`Icoon van ${label}`} src={icon} width={16} height={16} />
      <span className='ms-2'>{label}</span>
    </div>
  )

const PoiInformationOverlay = ({
  feedbackForm,
  feature,
  canNavigateTo,
  canGiveTravelAdvise,
  handleNavigationClick,
}) => (
  <div>
    <h4>{feature.getProperty('name')}</h4>
    <p>{feature.getProperty('description')}</p>
    <div className='row mb-3'>
      <OverlayItem
        icon='/assets/icons/wheelchair.svg'
        label='Rolstoeltoegankelijk'
        show={feature.getProperty('wheelchairAccessible') === '1'}
      />
      <OverlayItem
        icon='/assets/icons/check.svg'
        label='Voetgangers & fietsers'
        show={
          feature.getProperty('pedestrianAccessible') === '1' &&
          feature.getProperty('bikerAccessible') === '1'
        }
      />
      <OverlayItem
        icon='/assets/icons/check.svg'
        label='Voetgangers'
        show={
          feature.getProperty('pedestrianAccessible') === '1' &&
          !feature.getProperty('bikerAccessible')
        }
      />
      <OverlayItem
        icon='/assets/icons/wheelchair.svg'
        label='Fietsers'
        show={
          feature.getProperty('bikerAccessible') === '1' &&
          !feature.getProperty('pedestrianAccessible')
        }
      />
      <OverlayItem
        icon='/assets/icons/check.svg'
        label='Motorvoertuigen'
        show={feature.getProperty('motorAccessible') === '1'}
      />
      <OverlayItem
        icon='/assets/icons/no-check.svg'
        label='Motorvoertuigen'
        show={feature.getProperty('motorAccessible') === '0'}
      />
    </div>

    <div className='row'>
      {canNavigateTo && (
        <OverlayItem
          icon='/assets/icons/navigation.svg'
          label={<LinkButton onClick={handleNavigationClick}>Navigeer hierheen</LinkButton>}
          show
        />
      )}
      {/* In the case of polygons and atmospheric areas, we want to display a different text*/}
      {canGiveTravelAdvise && (
        <OverlayItem
          icon='/assets/icons/navigation.svg'
          label={<LinkButton onClick={handleNavigationClick}>Reisadvies</LinkButton>}
          show
        />
      )}
      <OverlayItem
        icon='/assets/icons/flag.svg'
        label={
          <FeedbackFormLink href={feedbackForm.replace('{poi}', feature.getProperty('name'))}>
            Meld onjuist- of onvolkomendheden
          </FeedbackFormLink>
        }
        show
      />
    </div>
  </div>
)

export default PoiInformationOverlay
